export type TrialVariant = 'C' | 'D';

export type TrialVariantState =
  | { status: 'loading'; variant: null }
  | { status: 'resolved'; variant: null | TrialVariant };

export const isTrialVariant = (value: unknown): value is TrialVariant => value === 'C' || value === 'D';
